export class HubGooglePlaceBasicData {
  place_id: string;
  name: string;
  types: string[];
  formatted_address: string;
  geometry: {
    location: { lat: string; lng: string };
  };
  opening_hours: {
    open_now: boolean;
  };
  photos: [
    {
      cover: string;
      height: number;
      width: number;
      photo_reference: string;
    }
  ];
  rating: number;
  user_ratings_total: number;
  checked: boolean;

  uploadedImage: File;
  existed: boolean;
}

export class HubPlaceAdditionalData {
  place_id: string;
  reviews: GooglePlaceReview[]; // load from Google place details API
  googleReviews: GooglePlaceReview[]; // load from database
  website: string;
  url: string;
  price_level: number; // pulled from google api
  priceRange: number; // user set in dashboard
  // priceLevelArray: {}[];
  user_ratings_total: number;
  opening_hours: {
    open_now: boolean;
    periods: {
      open: {
        day: number;
        time: string;
      };
      close: {
        day: number;
        time: string;
      };
    }[];
    weekday_text: string[];
  };
  photos: {
    height: number;
    photo_reference: string;
    width: number;
    html_attributions: any;
  }[];
  // photos: any[];
  photoSources: string[];
  formatted_phone_number: string;
  phone: string;
  hostLink: string;
  allowedGooglePhotos: string[];
  blockedGooglePhotos: string[];
  appKey: string;
  business_status: string; // for google places, stands for if the place is open normally (OPERATIONAL), or CLOSED_TEMPORARILY or CLOSED_PERMANENTLY
  isNotExistInSource: boolean; // a place might be removed from Google, this indicates if it is removed
}

export class GooglePlaceReview {
  author_name: string;
  author_url: string;
  language: string;
  profile_photo_url: string;
  rating: number;
  stars: any[];
  relative_time_description: string;
  text: string;
  time: number;
  dateTimeISOString: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/models/hub/hub.google.place.data.ts